import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { UIContextContainer } from './components/UI/UIContext';

import './i18n';

Sentry.init({
  dsn: import.meta.env.VITE_APP_DSN_SENTRY,
  integrations: [Sentry.browserTracingIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [import.meta.env.VITE_PUBLIC_URL],
  enabled:
    ['development', 'test'].indexOf(import.meta.env.NODE_ENV ?? '') === -1,
});

const container = document.getElementById('app');
const root = ReactDOMClient.createRoot(container!);
root.render(
  <React.StrictMode>
    <UIContextContainer>
      <App />
    </UIContextContainer>
  </React.StrictMode>
);
